<template>
    <div class="p-3">
        <h4 class="text-dark">Control Center: Tracker Customizations</h4>

        <h5 class="text-dark mt-5">General</h5>

        <section class="mt-3">
            <form>
                <div class="form-group row">
                    <label
                        for="is_customizations_enabled"
                        class="col-sm-6 col-form-label font-weight-bold"
                        >Customize organization trackers:</label
                    >
                    <div class="col-sm-2 mt-2">
                        <toggle-button
                            id="is_customizations_enabled"
                            :value="!!organization_.is_customizations_enabled"
                            color="#D64571"
                            @change="updateCustomizationsEnabled($event.value)"
                            :labels="true"
                            :sync="true"
                        />
                    </div>
                </div>

                <div class="form-group row" v-show="!!organization_.is_customizations_enabled">
                    <label
                        for="is_customizations_global"
                        class="col-sm-6 col-form-label font-weight-bold"
                        >Disable individual customizations and use organization settings:</label
                    >
                    <div class="col-sm-2 mt-2">
                        <toggle-button
                            id="is_customizations_global"
                            :value="!!organization_.is_customizations_global"
                            color="#D64571"
                            @change="updateCustomizationsGlobal($event.value)"
                            :labels="true"
                            :sync="true"
                        />
                    </div>
                </div>
            </form>
        </section>

        <tracker-list
            v-show="!!organization_.is_customizations_enabled"
            :customization-owner="organization"
            :endpoint="'organizations'"
            :tracker-types="trackerTypes"
            @set-parent-prop="propSetFromChild($event)"
        ></tracker-list>

        <div class="my-2">
            <div v-if="success" class="alert alert-success">
                <a href="#" class="close" data-dismiss="alert">&times;</a>
                <span>Your changes have been saved.</span>
            </div>
            <errors :errors="errors"></errors>
        </div>
    </div>
</template>

<script>
import { helpers } from "../../plugins/helpers";
import { errors } from "../../plugins/errors";
import TrackerList from "../tracker/TrackerList";

export default {
    name: "TrackerCustomizations",
    props: ["organization"],
    mixins: [errors],
    components: { TrackerList },
    inject: ["trackerTypes"],
    data() {
        return {
            organization_: {
                is_customizations_enabled: false,
                is_customizations_global: false,
            },
            success: false,
            user: {},
        };
    },
    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            this.getOrganization();
        },

        getOrganization() {
            axios.get(`/api/organizations/${this.organization.id}`).then(r => {
                Object.keys(this.organization_).forEach(k => {
                    this.organization_[k] = r.data.data[k];
                });
            });
        },

        updateCustomizationsEnabled(value) {
            this.organization_.is_customizations_enabled = value ? 1 : 0;
            if (!this.organization_.is_customizations_enabled) {
                this.organization_.is_customizations_global = 0;
            }
            this.updateOrganization();
        },

        updateCustomizationsGlobal(value) {
            this.organization_.is_customizations_global = value ? 1 : 0;
            this.updateOrganization();
        },

        updateOrganization() {
            const payload = { ...this.organization_ };
            axios.patch(`/api/organizations/${this.organization.id}`, payload).then(r => {
                Object.keys(this.organization_).forEach(k => {
                    this.organization_[k] = r.data.data[k];
                });
            });
        },
    },
};
</script>

<style scoped></style>
